(function () {
  'use strict';

  // Sticky Add-to-cart bar: show it as soon as the real Add to cart button leaves the screen.
  //
  // Prestige's own <product-sticky-bar> waits for the whole product FORM to scroll above the
  // viewport. That was fine upstream, where the form wrapped little more than the buy buttons, but
  // this theme hoists the form around the entire block list (see snippets/product-info.liquid) so
  // that SC Product Options can find a parent form. The trigger therefore waited for the last block
  // in the info column -- description, share, reviews -- leaving ~650px of scrolling with no buy
  // button anywhere, and much more on a product with a tall gallery.
  //
  // theme.js registers its version behind `if (!window.customElements.get('product-sticky-bar'))`,
  // so defining ours first takes precedence and the bundled file is left untouched. This script must
  // therefore run BEFORE theme.js -- it is loaded from layout/theme.liquid immediately above it.

  if (window.customElements.get('product-sticky-bar')) return;

  var DESKTOP_MIN_WIDTH = 700; // Matches the bar's own breakpoint in theme.css.

  var KjpProductStickyBar = function () {
    return Reflect.construct(HTMLElement, [], KjpProductStickyBar);
  };

  KjpProductStickyBar.prototype = Object.create(HTMLElement.prototype, {
    constructor: { value: KjpProductStickyBar, configurable: true, writable: true }
  });
  Object.setPrototypeOf(KjpProductStickyBar, HTMLElement);

  var proto = KjpProductStickyBar.prototype;

  proto.connectedCallback = function () {
    this.setAttribute('data-kjp-sticky-atc', ''); // Marker: proves this build is the one running.

    this.form = document.forms[this.getAttribute('form')];
    this.footerElement = document.querySelector('.shopify-section--footer');

    this.onScroll = this.scheduleUpdate.bind(this);
    this.onRerender = this.refresh.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    window.addEventListener('load', this.onRerender);

    // Prestige swaps <buy-buttons> for the selected variant, so the cached node has to be dropped.
    if (this.form) {
      this.form.addEventListener('variant:change', this.onRerender);
      this.form.addEventListener('product:rerender', this.onRerender);
    }

    this.refresh();
  };

  proto.disconnectedCallback = function () {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    window.removeEventListener('load', this.onRerender);

    if (this.form) {
      this.form.removeEventListener('variant:change', this.onRerender);
      this.form.removeEventListener('product:rerender', this.onRerender);
    }
  };

  /**
   * The Add to cart button inside the product information, never the copy the bar itself carries
   * (main-product.liquid marks that one with data-sticky-buy). Cached, but re-queried whenever the
   * cached node has been taken out of the document by a re-render.
   */
  proto.getBuyButton = function () {
    if (this.buyButton && this.buyButton.isConnected) return this.buyButton;

    var scope = this.form && this.form.isConnected ? this.form : document;
    var candidates = scope.querySelectorAll('buy-buttons, .buy-buttons');

    this.buyButton = null;

    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].hasAttribute('data-sticky-buy') && !this.contains(candidates[i])) {
        this.buyButton = candidates[i];
        break;
      }
    }

    return this.buyButton;
  };

  /**
   * How far past the button the customer scrolls before the bar appears, as a share of the screen
   * height. 0 means the moment it leaves the viewport.
   */
  proto.getOffsetPx = function () {
    var isDesktop = window.innerWidth >= DESKTOP_MIN_WIDTH;
    var raw = this.getAttribute(isDesktop ? 'data-offset-desktop' : 'data-offset-mobile');
    var percent = parseFloat(raw);

    if (!isFinite(percent) || percent <= 0) return 0;

    return Math.round((Math.min(percent, 100) / 100) * window.innerHeight);
  };

  /** Drop the cached button (it may have just been replaced) and re-measure. */
  proto.refresh = function () {
    this.buyButton = null;
    this.update();
  };

  proto.scheduleUpdate = function () {
    if (this.updateScheduled) return;

    this.updateScheduled = true;
    window.requestAnimationFrame(function () {
      this.updateScheduled = false;
      this.update();
    }.bind(this));
  };

  /**
   * Measured from the live geometry on each frame rather than from an IntersectionObserver.
   * An observer looked tidier but was wrong twice over: it reports the boundary crossing with the
   * button's edge exactly on the viewport edge, so the state latched on whichever side that landed
   * and never fired again; and because Prestige replaces <buy-buttons> per variant, an observer
   * could end up watching a detached node and go silent. Both made the bar's behaviour depend on
   * how the customer arrived at a position -- scrolling up behaved differently from scrolling down.
   */
  proto.update = function () {
    var button = this.getBuyButton();

    // Mid re-render: keep the bar down rather than stranding it on screen.
    if (!button) {
      this.classList.remove('is-visible');
      return;
    }

    var scrolledPast = button.getBoundingClientRect().bottom <= -this.getOffsetPx();
    var footerVisible = false;

    if (this.footerElement) {
      var footer = this.footerElement.getBoundingClientRect();
      footerVisible = footer.top < window.innerHeight && footer.bottom > 0;
    }

    this.classList.toggle('is-visible', scrolledPast && !footerVisible);
  };

  window.customElements.define('product-sticky-bar', KjpProductStickyBar);
})();
